import React from "react";
// nodejs library that concatenates classes
import classNames from "classnames";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";

// core components
import Header from "componentsHomePage/Header/Header.js";
import Footer from "components/Footers/AdminFooter.js";
import HeaderLinks from "componentsHomePage/Header/HeaderLinks.js";
import Parallax from "componentsHomePage/Parallax/Parallax.js";

import styles from "./assets/jss/material-kit-react/views/landingPage.js";

// Sections for this page
import ProductSection from "./Sections/ProductSection.js";
//import TeamSection from "./Sections/TeamSection.js";

const useStyles = makeStyles(styles);
   
export default function LandingPage(props) {
  const classes = useStyles();
  const { ...rest } = props;

  return (
    <div style={{backgroundColor:'#0B22E8'}}>
      <Header
        color="transparent"
        brand="Celebrationjump LDA"
        rightLinks={<HeaderLinks />}
        fixed
        changeColorOnScroll={{
          height: 300,
          color: "info",
        }}
        {...rest}
      />
      <Parallax filter/>
      <div className={classNames(classes.main, classes.mainRaised)} >
        <div className={classes.container}>
          <ProductSection />
          {/*<TeamSection/>*/}
        </div>
      </div>
      <Footer />
    </div>
  );
}
